import { Palette } from '@/themes/themeOverrides/Palette';

export const RaSingleFieldListStyles = {
    styleOverrides: {
        root: {
            '& .RaSingleFieldList-link > *': {
                color: `${Palette.black} !important`,
            },
        },
    },
};
